import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import { Divider } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { useTranslation } from 'react-i18next';

function PlanetAspects({ tableData }) {
    const { t } = useTranslation();

    const dataTableData = {
        columns: [
            { Header: t("PLANET"), accessor: "planet" },
            { Header: t("Nekatha"), accessor: "nekathaAdhipathi" },
            { Header: t("UpaGraha"), accessor: "upaGraha" },
            { Header: t("BhavaPlanetAspectsCol4"), accessor: "nakAdipathiThenpathBhavaya" },
            { Header: t("BhavaPlanetAspectsCol5"), accessor: "thenpathBhavaya" },
            { Header: t("BhavaPlanetAspectsCol6"), accessor: "nakAdipathiAithiBhavaya" },
            { Header: t("BhavaPlanetAspectsCol7"), accessor: "aithiBhavaya" }
        ],
        rows: tableData
    }

    return (
        <MDBox pt={0} pb={1} id="planet-aspects-ref">
            <MDBox mb={1}>
                <Card>
                    <MDBox p={3} lineHeight={1} mb={0} display="flex" alignItems="center">
                        <MDTypography variant="h5" fontWeight="medium">
                            {t("BhavaPlanetAspectsTitle")}
                        </MDTypography>
                        <Divider variant="fullWidth" sx={{ flexGrow: 1, marginLeft: 2 }} />
                    </MDBox>
                    <DataTable
                        canSearch={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        table={dataTableData} />
                </Card>
            </MDBox>
        </MDBox>
    );
};

PlanetAspects.propTypes = {
    tableData: PropTypes.any
};

export default PlanetAspects;
